import { render, staticRenderFns } from "./DisplayPreviews.vue?vue&type=template&id=36df3be4&scoped=true&"
import script from "./DisplayPreviews.vue?vue&type=script&lang=js&"
export * from "./DisplayPreviews.vue?vue&type=script&lang=js&"
import style0 from "./DisplayPreviews.vue?vue&type=style&index=0&id=36df3be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df3be4",
  null
  
)

export default component.exports